import {
  useLocation,
} from "react-router-dom";

import {
  getLanguageFromPath,
} from "../site/config/routes";

import Hero from "../template/components/sections/Hero";
import EditorialIntro from "../template/components/sections/EditorialIntro";
import PortfolioStory from "../template/components/sections/PortfolioStory";
import SessionsSection from "../template/components/sections/SessionsSection";
import AboutSection from "../template/components/sections/AboutSection";
import TestimonialsSection from "../template/components/sections/TestimonialsSection";
import ContactSection from "../template/components/sections/ContactSection";

import FaqSection from "../template/components/common/FaqSection";
import HomeScrollTracker from "../template/components/common/HomeScrollTracker";
import MobileStickyCta from "../template/components/common/MobileStickyCta";

import Footer from "../template/components/layout/Footer";

/*
  ============================================================
  PHOTOGRAPHY PREMIUM
  HomePage
  ============================================================

  Etusivu rakennetaan itsenäisistä premium-osioista.
*/

export default function HomePage({
  theme = "ivory",
}) {
  const location =
    useLocation();

  const language =
    getLanguageFromPath(
      location.pathname
    );

  return (
    <>
      <HomeScrollTracker
        language={language}
      />

      <MobileStickyCta
        language={language}
      />

      <div
        id="home-hero"
        data-home-section="hero"
      >
        <Hero
          language={language}
          theme={theme}
        />

        <EditorialIntro
          theme={theme}
        />
      </div>

      <div
        id="home-portfolio"
        data-home-section="portfolio"
      >
        <PortfolioStory />
      </div>

      <div
        id="home-sessions"
        data-home-section="sessions"
      >
        <SessionsSection
          language={language}
        />
      </div>

      <div
        id="home-about"
        data-home-section="about"
      >
        <AboutSection
          language={language}
        />
      </div>

      <div
        id="home-testimonials"
        data-home-section="testimonials"
      >
        <TestimonialsSection
          language={language}
        />
      </div>

      <div
        id="home-faq"
        data-home-section="faq"
      >
        <FaqSection
          language={language}
          sectionKey="sessions"
        />
      </div>

      <div
        id="home-contact"
        data-home-section="contact"
      >
        <ContactSection
          language={language}
        />
      </div>

      <Footer
        language={language}
      />
    </>
  );
}